import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function initEventsSlider() {
  const swiper = new Swiper(".events-slider", {
    slidesPerView: "auto",
    spaceBetween: 1,
    slidesPerGroup: 2,
    // loop: true,
    navigation: {
      nextEl: ".events-slider-next",
      prevEl: ".events-slider-prev",
    },
    pagination: {
      el: ".events-slider-progressbar",
      type: "progressbar",
      clickable: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    breakpoints: {
      768: {
        slidesPerGroup: 3,
      },
      1024: {
        slidesPerGroup: 4,
      },
    },
  });
}

function initGalleriesSlider() {
  const swiper = new Swiper(".galleries-slider", {
    slidesPerView: "auto",
    spaceBetween: -1,
    // loop: true,
    slidesPerGroup: 1,
    navigation: {
      nextEl: ".galleries-slider-next",
      prevEl: ".galleries-slider-prev",
    },
    pagination: {
      el: ".galleries-slider-progressbar",
      type: "progressbar",
      clickable: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    breakpoints: {
      768: {
        slidesPerGroup: 3,
      },
      1400: {
        slidesPerGroup: 4,
      },
    },
  });
}
export { initEventsSlider, initGalleriesSlider };
